






















































































  import Vue from 'vue'
  import { Component, Prop, Watch } from 'vue-property-decorator'
import { Delegation, DelegationsUpdate, UserInformations } from '@/services/connecteur'
import serviceModule from '@/store/modules/ServiceModule'
  import DatePicker from '@/components/shared/DatePicker.vue'
import userModule from '@/store/modules/UserModule'
  import VAutocompleteWithValidation from '@/components/Inputs/VAutocompleteWithValidation.vue'

  @Component({
    components: {
      DatePicker,
      VAutocompleteWithValidation
    }
  })
  export default class UserDelegations extends Vue {
    @Prop()
    public open!: boolean

    @Prop()
    public user!: UserInformations

    public delegations = new Array<Delegation>()
    public users = new Array<UserInformations>()
    public loading = false
    public headers: any[] = [
      {
        text: this.$t('delegations.surrogate'),
        value: 'surrogateUserId'
      },
      {
        text: this.$t('delegations.startDate'),
        value: 'startDate'
      },
      {
        text: this.$t('delegations.endDate'),
        value: 'endDate'
      },
      {
        value: 'actions',
        sortable: false
      }
    ]

    public get title () {
      return userModule.id === this.user.id
        ? this.$t('delegations.configureForSelf')
        : this.$t('delegations.configureForUser', { name: this.user.fullName })
    }

    @Watch('open', { immediate: true })
    public async onOpen() {
      if (this.open) {
        this.users = []
        this.delegations = []
        this.users = await serviceModule.delegationApi.getSurrogates(this.user.id)
        this.delegations = await serviceModule.delegationApi.getDelegations(this.user.id)
      }
    }

    public async onConfirm() {
      // @ts-ignore
      const success = await this.$refs.form.validate()
      if (success) {
        this.loading = true
        await serviceModule.delegationApi.update(new DelegationsUpdate({ delegations: this.delegations, userId: this.user.id }))
        this.loading = false
        this.$emit('confirm')
        userModule.loadSurrogacies()
      }
    }

    public addDelegation() {
      this.delegations.push(new Delegation({ surrogateUserId: undefined, startDate: undefined, endDate: undefined }))
    }

    public deleteDelegation(item: Delegation) {
      this.delegations.splice(this.delegations.indexOf(item), 1)
    }
  }
